import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { useHistory } from 'react-router-dom';
import { MERCH_CARD } from '../../../../constants/tracking/TrackingSources';
import { trackClickedLink } from '../../../../utils/tracking/trackingEventUtils';
import { BrandingAndLimitPriorityFeatures } from '../../../../v2/components/merch-card/feature-display/BrandingAndLimitPriorityFeatures';
import { UncategorizedPriorityFeatures } from '../../../../v2/components/merch-card/feature-display/UncategorizedPriorityFeatures';
import { useIsFreePortal } from '../../../../v2/hooks/useProductInventory';
import SkeletonLoadWrapper from '../../../common/loading/SkeletonLoadWrapper';
import { StandardLowerTierMessage } from '../StandardLowerTierMessage';
import { useCategorizedPriorityFeatures } from '../useFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandardFeaturesContainer = ({
  productLevel,
  productLine,
  apiName,
  isCollapsible = false
}) => {
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const {
    loading: isPriorityFeaturesLoading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  } = useCategorizedPriorityFeatures({
    apiName
  });
  const loading = isInventoryLoading || isPriorityFeaturesLoading;
  const history = useHistory();
  const handleClick = () => {
    trackClickedLink({
      name: 'business-objective-link',
      value: getI18nText('merchCards.priorityFeatures.freeToolsWithLimits', {
        locale: 'en-us'
      }),
      type: 'internal',
      url: '/crm',
      trackingSource: MERCH_CARD
    });
    history.push('/crm');
  };
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [48, 48],
    widths: ['100%', '100%'],
    children: brandingAndLimitFeatures.length ? /*#__PURE__*/_jsx(BrandingAndLimitPriorityFeatures, {
      brandingAndLimitFeatures: brandingAndLimitFeatures,
      uncategorizedFeatures: uncategorizedFeatures,
      handleClickFreeToolsWithLimitsLink: handleClick,
      isCollapsible: isCollapsible,
      isFreePortal: isFreePortal
    }) : uncategorizedFeatures.length ? /*#__PURE__*/_jsx(UncategorizedPriorityFeatures, {
      uncategorizedFeatures: uncategorizedFeatures,
      lowerTierMessage: /*#__PURE__*/_jsx(StandardLowerTierMessage, {
        productLevel: productLevel,
        productLine: productLine,
        handleClick: handleClick,
        isFreePortal: isFreePortal
      }),
      isCollapsible: isCollapsible
    }) : null
  });
};